import React from "react";
import { Image, Table, Tag, Popconfirm, Button } from "antd";
import { ColumnType } from "antd/es/table";
import { RiDeleteBin6Line } from "react-icons/ri";
import { FiEdit3 } from "react-icons/fi";
import { renderIcon, renderTableText } from "../../../../lib/utils";
import { BsDownload } from "react-icons/bs";
import MyPagination from "../../../../views/components/Pagination";
import { IFormFieldResponse } from "../../../../types/api/form-fields";
import { useNavigate } from "react-router-dom";
import { IAuthorPayload } from "../../../../types/api/author";

const DeleteIcon = renderIcon(RiDeleteBin6Line);
const EditIcon = renderIcon(FiEdit3);

interface AuthorTableProps {
  data?: IAuthorPayload[];
  handleDelete?: (id: string) => void;
  form?: any;
  loading?: boolean;
  DEFAULT_NUQS_CONFIG?: any;
  qData?: any;
  refetch?: any;
}


const AuthorTable: React.FC<AuthorTableProps> = ({
  data = [],
  loading = false,
  DEFAULT_NUQS_CONFIG,
  qData,
  refetch,
  handleDelete
}) => {
  const navigate = useNavigate();

  const columns: ColumnType<IAuthorPayload>[] = [
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      render: (v) => renderTableText(v),
    },
     {
         title: "Avatar",
         dataIndex: "avatar",
         key: "avatar",
         render : (v) => {
           return (
             <div className=" size-12 rounded-full overflow-hidden">
               <Image src={v} alt="image" className="w-full h-full object-cover" />
             </div>
           )
         }
       },
           {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (status: boolean) => (
        <Tag color={status ? "green" : "red"} bordered>
          {status ? "Active" : "Inactive"}
        </Tag>
      ),
    },
    
    {
      title: "Action",
      key: "action",
      align: "right",
      render: (_: any, row: any) => (
        <div className="flex items-center justify-end gap-2 md:gap-3 md:pr-3">
          <EditIcon
            className="cursor-pointer text-primary text-[18px] md:text-[20px]"
            onClick={() => navigate(`/website/blog/edit/${row?._id}`)}
          />
          <Popconfirm
                      title="Are you sure to delete this row?"
                      onConfirm={() => handleDelete?.(row?._id)}
                      okText="Yes"
                      cancelText="No"
                    >
                      <DeleteIcon className="cursor-pointer text-primary hover:text-red-600 text-[18px] md:text-[20px]" />
                    </Popconfirm>
        </div>
      ),
    },
  ];

  return (
    <div>
      <div>
        <Table
          dataSource={data || []}
          columns={columns}
          rowKey={(item: any) => item?._id}
          pagination={false}
          size="middle"
          bordered={false}
          loading={loading}
          className="custom-table-class rounded-lg border border-gray-200 shadow-md"
          footer={() => (
            <MyPagination
              qData={qData}
              onChange={refetch}
              total={qData?.total}
              DEFAULT_NUQS_CONFIG={DEFAULT_NUQS_CONFIG}
            />
          )}
        />
      </div>
    </div>
  );
};

export default AuthorTable;
